import styled from 'styled-components';
import { trackAnalyticsNew } from '../../../../lib/utils';
import { DATA_TRACK_TYPE_INTERNAL } from '../../../../lib/constants';

const ShopNavLettersDiv = styled.div`
  margin-bottom: ${p => p.theme.unit(4)};
  overflow-wrap: break-word;
  display: flex;
  flex-wrap: wrap;
`;

const ShopsNavLetterWrapper = styled.div`
  display: inline-flex;
  align-items: flex-end;
  margin: 0;
  padding: ${({ theme }) => theme.unit(1)};
`;

const ShopNavLetter = styled.span`
  ${({ theme }) => theme.typographyRebrand.heading['2xl']}
  text-transform: uppercase;
  text-align: left;
  color: ${({ theme }) => theme.c.text.disabled};
  text-decoration: none;
  position: relative;
  outline: 2px solid transparent;
  outline-offset: 2px;
`;

const ShopNavLetterAnchor = styled(ShopNavLetter.withComponent('a'))`
  color: ${({ theme }) => theme.c.text.interactive};
  cursor: pointer;
  text-decoration: none;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 2px;
    background-color: ${({ theme }) => theme.c.bg.interactive};
  }

  &:hover {
    color: ${({ theme }) => theme.c.text['interactive-hover']};
  }

  &:hover::after {
    background-color: ${({ theme }) => theme.c.text['interactive-hover']};
  }

  &:active {
    color: ${({ theme }) => theme.c.text.interactive};
  }

  &:focus-visible {
    outline-color: ${({ theme }) => theme.c.text.interactive};
  }
`;

const ShopNavigationLetters = ({ shopOrder = {}, isMobile }) => {
  const { order = [] } = shopOrder;
  const alphabet = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

  const allLetters = alphabet.map((letter) => {
    const hasShops = order.includes(letter);
    const track = hasShops ? trackAnalyticsNew({
      url: `#${letter}`,
      location: 'page',
      name: `filter-by-alphabet:${letter.toLowerCase()}`,
    }) : null;

    return (
      <ShopsNavLetterWrapper key={`shop-dir-letter-${letter}`} isMobile={isMobile}>
        {hasShops ? (
          <ShopNavLetterAnchor
            href={track.url}
            data-track-id={track.dataTrackingId}
            data-track-click={track.dataTrack}
            data-track-type={DATA_TRACK_TYPE_INTERNAL}
          >
            {letter}
          </ShopNavLetterAnchor>
        ) : (
          <ShopNavLetter>
            {letter}
          </ShopNavLetter>
        )}
      </ShopsNavLetterWrapper>
    );
  });

  return (
    <ShopNavLettersDiv>
      {allLetters}
    </ShopNavLettersDiv>
  );
};

export default ShopNavigationLetters;
